let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("dXN7B")).then(() => parcelRequire('lzjf5'));